"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.object.get-prototype-of");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.reflect.construct");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Button = _interopRequireDefault(require("@icare/components/lib/Button"));

var _GenericForm = _interopRequireDefault(require("@icare/forms/lib/components/GenericForm"));

var _FormErrorSummary = _interopRequireDefault(require("@icare/forms/lib/components/FormErrorSummary"));

var _LayoutField = _interopRequireDefault(require("@icare/forms/lib/components/LayoutField"));

var _ContentHeader = _interopRequireDefault(require("@icare/components/lib/ContentHeader"));

var _Message = _interopRequireDefault(require("@icare/components/lib/Message"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ExpiredLinkPage = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(ExpiredLinkPage, _React$PureComponent);

  var _super = _createSuper(ExpiredLinkPage);

  function ExpiredLinkPage() {
    var _this;

    _classCallCheck(this, ExpiredLinkPage);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "_handleSubmit", function (values) {
      _this.props.onSubmit(values);
    });

    return _this;
  }

  _createClass(ExpiredLinkPage, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          content = _this$props.content,
          form = _this$props.form,
          resendSuccess = _this$props.resendSuccess,
          portalIdentifier = _this$props.portalIdentifier;
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !resendSuccess ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_ContentHeader.default, {
        heading: content.header.title,
        subHeading: content.header.intro
      }), portalIdentifier && /*#__PURE__*/_react.default.createElement(_GenericForm.default, {
        form: form,
        onSubmit: this._handleSubmit
      }, /*#__PURE__*/_react.default.createElement(_LayoutField.default, {
        form: form,
        fieldId: "emailAddress"
      }), /*#__PURE__*/_react.default.createElement(_FormErrorSummary.default, {
        form: form,
        validateAfterSubmit: true
      }), /*#__PURE__*/_react.default.createElement(_Button.default, {
        tag: "button",
        type: "submit"
      }, content.resendEmailButton))) : /*#__PURE__*/_react.default.createElement(_Message.default, {
        type: _Message.default.type.SUCCESS,
        title: content.resendActivationLinkSection.title
      }, content.resendActivationLinkSection.text));
    }
  }]);

  return ExpiredLinkPage;
}(_react.default.PureComponent);

exports.default = ExpiredLinkPage;

_defineProperty(ExpiredLinkPage, "propTypes", {
  content: _propTypes.default.shape({
    header: _propTypes.default.shape({
      title: _propTypes.default.string,
      intro: _propTypes.default.string
    }),
    resendActivationLinkSection: _propTypes.default.shape({
      title: _propTypes.default.string,
      text: _propTypes.default.string
    }),
    resendEmailButton: _propTypes.default.string
  }).isRequired,
  onSubmit: _propTypes.default.func,
  form: _propTypes.default.object.isRequired,
  resendSuccess: _propTypes.default.bool.isRequired,

  /*
   * Portal Identifier is a mandatory field which needs to be passed by all portals.
   * Important: If this identifier is not present we do not need to render the form, as it specifies
   * that portals have not yet aligned to the new registration flow
   */
  portalIdentifier: _propTypes.default.string.isRequired
});

_defineProperty(ExpiredLinkPage, "defaultProps", {
  onSubmit: function onSubmit() {}
});
//# sourceMappingURL=ExpiredLinkPage.js.map